const kDefaultMax = 320;
const kFallback = 200;

/**
 * Aspect-ratio-preserving size for an image or video bubble. Caps the
 * larger dimension at `maxSize` (default 320px) and shrinks the other
 * proportionally. Falls back to a 200×200 square if intrinsic
 * dimensions are missing.
 */
export function getMessageMediaSize(
  intrinsicWidth: number | undefined,
  intrinsicHeight: number | undefined,
  maxSize: number = kDefaultMax,
): { width: number; height: number } {
  let width = intrinsicWidth || kFallback;
  let height = intrinsicHeight || kFallback;
  const aspect = width / height;

  if (width > maxSize) {
    width = Math.round(maxSize);
    height = Math.round(width / aspect);
  }
  if (height > maxSize) {
    height = maxSize;
    width = Math.round(aspect * maxSize);
  }
  return { width, height };
}
